module.exports = __webpack_public_path__ + "static/media/Message_Inbox_Loyalty_Promo@3x.03f6c134.png";